/*
 * Copyright (c) 2020-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

import { useNavigate } from 'react-router-dom';
import { authService } from '@services/auth.service';
import { useAuthStore } from '@store/auth.store';
import { msalInstance } from '@/lib/msal';

export function useAuth() {
  const { clearAuth } = useAuthStore();
  const navigate = useNavigate();

  const logout = async () => {
    // Clear backend session
    try {
      await authService.logout();
    } catch {
      /* ignore */
    }

    // Clear local app state
    clearAuth();

    // Sign out from Microsoft so the account picker appears on next login
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      await msalInstance.logoutRedirect({
        account: accounts[0],
        postLogoutRedirectUri: window.location.origin + '/login',
      });
    } else {
      navigate('/login');
    }
  };

  return { logout };
}
